<template>
  <div class="advantage-addition-wrapper">
    <div class="advantage-addition">
      <img src="/static/img/icons/delete.svg" class="delete-icon" 
        @click="deleteInvestmentAdvantage(advantage.id)"
      />

      <b-field>
          <b-input placeholder="Заголовок" v-model="advantage.title" 
            @change="updateInvestmentAdvantage(advantage)"
          ></b-input>
      </b-field>

      <b-field>
        <b-input placeholder="Текст" type="textarea" 
          v-model="advantage.description" @change="updateInvestmentAdvantage(advantage)"
        ></b-input>
      </b-field>

      <div class="learn-more">
        <b-field class="learn-more-field">
          <b-input placeholder="Заголовок" v-model="advantage.learnMoreButton.title" required />
          <b-input placeholder="Ссылка" v-model="advantage.learnMoreButton.url" required />
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'Advantage',
    data () {
      return {
      }
    },
    props: {
      advantage: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions(['deleteInvestmentAdvantage', 'updateInvestmentAdvantage'])
    }
  }
</script>

<style>
.advantage-addition-wrapper {
  background: #eeeeee;
  padding: 30px;
  margin: 20px 0px;
}

.advantage-addition, .service-description {
  max-width: 600px;
  margin: 0 auto;
  position: relative;
}

.delete-icon {
  width: 24px;
  position: absolute;
  top: -20px;
  right: -20px;
  z-index: 100;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// InvestmentAdvantage.vue?f698b2bc